import React, { useEffect, useState } from "react";
import classes from './TopicNode.module.css';
import { NavLink, useParams } from 'react-router-dom';
import editIcon from '../../../../assests/course/editIcon.png'
import deleteIcon from '../../../../assests/assessments/new/delete-icon.png'
import eyeOff from '../../../../assests/course/eyeOffIcon.png'
import lockIcon from '../../../../assests/course/lockIcon.png'
import * as PathRouter from '../../../../models/PathRoute'
import TopicsMenuNode from "./TopicsMenuNode";
import { useDispatch, useSelector } from "react-redux";
import ToastMessage from "../../../UI/ToastMessage";
import { assessmentsApi, lessonsApi, toCApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ForwardLessonBtn from "../../MaterialLibrary/ForwardLessonBtn";
import { ObjectTypeEnum } from "../../../../models/ObjectTypeEnum";
import { onKeyDown } from '../../../../service';
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import eyeOn from "../../../../assests/course/eyeOnIcon.png"
import { ActivityTypeEnum } from "../../../../models/ActivityTypeEnum";
const TopicNode = ({ isProfession, topicData, selectSubMenu, setSubTopicCurrentID, myClass, lessonId, disableEditLesson, disableDeleteLesson, defaultTopicId, startOpen, refreshTopicList, courseName, tocName, selectMenu, addNewLesson, studyGroupId, isDraggable }) => {


    const { guid } = useParams();
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const isSupervisor = useSelector(state => state.auth.user.permissions?.EditCourse);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const dispatch = useDispatch()
    const [showChildren, setShowChildren] = useState(topicData.children.length > 0 && startOpen)
    const [messagePopup, setMessagePopup] = useState()

    const finalAssessment = topicData?.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final);

    useEffect(() => {
        if (topicData.children && topicData.children.findIndex(x => x.id == guid) != -1) {
            setShowChildren(false);
            handleCurentSubMenuItem(guid)
        }
    }, [])

    function getLessonId(t) {
        if (t.children.length > 0) {
            return getLessonId(t.children[0])
        }
        if (t.isLesson)
            return t.id
        else
            return 0
    }

    const handleCurentSubMenuItem = (id) => {
        if (topicData.children.length > 0) {
            if (!selectSubMenu) {
                if (!showChildren) {
                    const nextLesson = topicData.children.find(x => x.visible)
                    setSubTopicCurrentID && setSubTopicCurrentID(getLessonId(nextLesson))
                }
                setShowChildren((prevShowChildren) => !prevShowChildren);
            }
            else {
                if (id != guid) {
                    setSubTopicCurrentID && setSubTopicCurrentID(id)
                    setShowChildren(true)
                }
                else {
                    setShowChildren((prevShowChildren) => !prevShowChildren);
                }
            }
        }
        else {
            (!selectSubMenu && topicData.isLesson || selectSubMenu) && setSubTopicCurrentID && setSubTopicCurrentID(id)
        }
    }

    const handleDelete = (e, status, message, id) => {
        e.stopPropagation()
        setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Warn} cancelFunc={() => setMessagePopup(false)} confirmFunc={(e) => deleteLessonConfirm(status, id)} content={message} />)
    }

    const deleteLessonConfirm = (status, id) => {
        if (status === "lesson") {
            lessonsApi.lessonsDeleteIdPost(topicData.id, (error, resdata, response) => {
                if (error?.status == 406) {
                    setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={(e) => setMessagePopup(false)} content={texts.errrMsgOnDeleteLessonWithAssessments} />)
                }
                else if (error?.status == 405) {
                    setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={(e) => setMessagePopup(false)} content={texts.errrMsgOnDeleteLessonWithSubmissions} />)
                }
                else if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "lessonsDeleteIdPost " + error.message, level: 2, component: "TopicNode", line: 70 }))
                }
                else {
                    setMessagePopup(<ToastMessage text={texts.MessageContentSuccessDeleteLessonStatus} color="green" close={() => setMessagePopup(null)} />)
                    if (refreshTopicList)
                        refreshTopicList()
                }
            })
        }
        else {
            if (status === "assessment") {
                assessmentsApi.assessmentsDeleteIdPost(id, (error, resdata, response) => {
                    if (error?.status == 406) {
                        setMessagePopup(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={(e) => setMessagePopup(false)} content={texts.errrMsgOnDeleteAssessmentsWithSubmissions} />)
                    }
                    else if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "MessageContentDeleteProjectStatus " + error.message, level: 2, component: "TopicNode", line: 83 }))
                    }
                    else {
                        setMessagePopup(<ToastMessage text={texts.MessageContentSuccessDeleteAssessmentStatus} color="green" close={() => setMessagePopup(null)} />)
                        if (refreshTopicList)
                            refreshTopicList()
                    }
                })
            }
        }
    }

    const handleLessonVisibility = () => {
        const toCUpdateInput = {
            id: topicData.id,
            name: topicData.name,
            description: topicData.description,
            active: topicData.active,
            visible: !topicData.visible,
            ...(!isProfession ? { studyGroupId: studyGroupId } : {})
        };
        toCApi.toCUpdatePost({ toCUpdateInput: toCUpdateInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCUpdatePost " + error.message, level: 1, component: "NodeTreeEditTopic", line: 63 }))
            }
            else {
                refreshTopicList()
            }
        })

    }

    return (
        <div className={`${classes[direction]}`}>
            {topicData && <div className={`${classes.SubMenuItemWarrper} ${guid === topicData.id ? classes.Select : ``} ${classes[myClass]}`}>
                <div className={`${guid === topicData.id ? classes.Current : ``}`}></div>
                <div className={`${classes.SubMenuSelected}`}></div>

                {myClass == "TreeEditCourse" && <div className={`${classes.SubMenuHr}  ${showChildren ? classes.CurrentItem : ``}`}></div>}

                <div className={classes.SubMenuItemContainer}>
                    <div className={` ${classes.SubMenuItem}  ${isDraggable && classes.DraggableSubMenuItem}`} onClick={() => handleCurentSubMenuItem(topicData.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCurentSubMenuItem(topicData.id))}>
                        <div className={`${classes.OpenIconWidth} ${showChildren && topicData.children.length > 0 ? classes.Open : topicData.children.length > 0 && classes.Closed}`}></div>
                        <div className={`${classes.topicIcon}  ${topicData.isLesson ? classes.Lesson : classes.Topic}`}></div>
                        {topicData.indexOnMap && !disableEditLesson && <div className={`${classes.IndexOnMap}`}>{topicData.indexOnMap}</div>}
                        {topicData && <div className={`${classes.SubMenuName}  ${showChildren ? classes.CurrentItem : ``}`}>{topicData.name}</div>}
                    </div>
                    {/* resort-phase2 Feature of managing lessons whether they are visual or not what toc */}
                    {/* {myClass == "TreeEditCourse" && !disableEditLesson && <div className={classes.EyeOff}><img src={topicData.visible ? eyeOn : eyeOff} alt="EyeOff" onClick={handleLessonVisibility} className={classes.EyeOffOnImg} /></div>} */}

                    {myClass == "TreeEditCourse" && !topicData.isLocked && !disableEditLesson && <div className={classes.Forward}><ForwardLessonBtn type={ObjectTypeEnum.Lesson} data={topicData} setMessage={setMessagePopup} ViewText={texts.copylinkOflesson} ></ForwardLessonBtn></div>}
                    {((isProfession && isSupervisor) || !topicData.isLocked) && <>
                        {lessonId && !disableEditLesson && <NavLink className={classes.Edit} to={`${homeUrl}/${PathRouter.LESSONS}/${lessonId}`} state={{ courseName: courseName, tocName: tocName, studyGroupId: studyGroupId, isProfession: isProfession }} ><img src={editIcon} alt="EditIcon" /></NavLink>}
                        {!disableDeleteLesson && !disableEditLesson && (topicData.isLesson == true && !topicData.children.length > 0) && <div className={classes.Delete} onClick={(e) => handleDelete(e, "lesson", texts.MessageContentDeleteLessonWarn)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleDelete(e, "lesson", texts.MessageContentDeleteLessonWarn))}><img src={deleteIcon} alt="DeleteIcon" /></div>}
                    </>}
                    {myClass == "TreeEditCourse" && !topicData.visible && <div className={classes.Icon}> <img src={eyeOff} alt="EyeOff" className={classes.IconImg} /> </div>}
                    {myClass == "TreeEditCourse" && !topicData.active && <div className={classes.Icon}> <img src={lockIcon} alt="notActive" className={classes.IconImg} /> </div>}
                </div>

                {myClass == "TreeEditCourse" && <div className={`${classes.SubMenuHr}  ${showChildren ? classes.CurrentItem : ``}`}></div>}

                {
                    showChildren && topicData.children && topicData.children.length > 0 ?
                        <div className={classes.SubMenuChild} >
                            <TopicsMenuNode
                                disableEditLesson={disableEditLesson}
                                disableDeleteLesson={disableDeleteLesson}
                                topicsData={topicData.children}
                                selectSubMenu={selectSubMenu}
                                selectMenu={selectMenu}
                                setSubTopicId={setSubTopicCurrentID}
                                toCParentId={topicData.id}
                                defaultTopicId={defaultTopicId}>
                            </TopicsMenuNode>
                        </div> : <></>
                }
                {topicData.isLesson && topicData.assessments?.sort((a, b) => a.externalId - b.externalId).map(a =>
                    <div key={a.id} className={` ${classes.FinalAssessmentItemContainer}  ${isDraggable && classes.DraggableFinalAssessmentItemContainer}`} >
                        <div className={`${classes.FinalAssessmentItem}`} onClick={() => handleCurentSubMenuItem(topicData.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCurentSubMenuItem(topicData.id))}>
                            <div className={`${classes.topicIcon} ${classes.Assessment} ${ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Learning ? classes.LearningAssessment : ''}`}></div>
                            <div className={`${classes.FinalAssessmentName}  ${showChildren ? classes.CurrentItem : ``}`}>{a.name}</div>
                        </div>
                        {!isProfession && <div className={classes.Forward}>
                            <ForwardLessonBtn
                                type={ObjectTypeEnum.Lesson}
                                data={topicData}
                                setMessage={setMessagePopup}
                                ViewText={texts.copylinkOflesson}
                                projectUrl={`${studyGroupId}/lesson/${topicData.id}/proj${ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Learning ? `?id=${a.externalId}` : ''}`}>
                            </ForwardLessonBtn>
                        </div>}
                        {((isProfession && isSupervisor) || !topicData.isLocked) && <>
                            {<NavLink className={classes.Edit} to={`${homeUrl} /${PathRouter.ASSESSMENTS}/${a.id}`} state={{ courseName: courseName, tocName: tocName, studyGroupId: studyGroupId, isProfession: isProfession, activityType: a.activityType }}><img src={editIcon} alt="EditIcon" /></NavLink>}
                            {<div className={classes.Delete} onClick={(e) => handleDelete(e, "assessment", texts.MessageContentDeleteAssessmentWarn, a.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleDelete(e, "assessment", texts.MessageContentDeleteAssessmentWarn, a.id))}><img src={deleteIcon} alt="DeleteIcon" /></div>}
                        </>}
                    </div>)}

                {addNewLesson && !disableEditLesson && topicData.isLesson && (!topicData.isLocked || isProfession) && !finalAssessment && <NavLink className={classes.NewCourseContainer} to={`${homeUrl}/${PathRouter.ASSESSMENTS}/${PathRouter.NEW}`} state={{ lessonId: lessonId, courseName: courseName, tocName: tocName, studyGroupId: studyGroupId, isProfession: isProfession, activityType: ActivityTypeEnum.Final }}>
                    <div className={classes.Circle}>+</div>
                    <p className={classes.NewCourseText}>{texts.addAssessmentToLesson}</p>
                </NavLink>}
            </div>}
            {messagePopup}
        </div>
    )
}

export default TopicNode